import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

function Footer() {
  const { t } = useTranslation();
  function scrollToTop() {
    // Scroll window to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // Also try scrolling document element and body
    if (document.documentElement) {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
    
    if (document.body) {
      document.body.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    // Try scrolling any scrollable containers
    const scrollableContainers = document.querySelectorAll(
      ".main-content, .app, main, .page-wrapper, [data-scroll-container]"
    );
    scrollableContainers.forEach((container) => {
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
  return (
    <div className="footer-wrapper">
      <div className="footer container flex">
        <div className="footer-content">
          <Link className="footer-img" to="/">
            <img className="footer-logo" src="/logoBlackLong.svg" alt="Logo" />
          </Link>
          <p className="fs-400 clr-white footer-text">
            {t("footer.trustedBy")}
          </p>
          <div className="footer-white">
            <div className="footer-white-content">
              <h4 className="fs-500">{t("footer.contactUs")}</h4>
              <div>
                <a
                  href="https://wa.me/+38344175555"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-white-item"
                >
                  <img src="/assets/icons/phone.svg" alt="Phone Icon" />
                  <p>+383 44 175 555</p>
                </a>
                <a
                  href="mailto:mtasllani@hotmail.com"
                  className="footer-white-item"
                >
                  <img src="/assets/icons/email.svg" alt="Email Icon" />
                  <p>mtasllani@hotmail.com</p>
                </a>
              </div>
            </div>
            <a
              href="https://www.google.com/maps/place/METAL+TEKNIKA+ASLLANI/data=!4m2!3m1!1s0x0:0xc8bd55f16afc3f89?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-white-item"
            >
              <img src="/assets/icons/location.svg" alt="Location Icon" />
              <p className="fs-400 green">
                Bresje , Fushë Kosovë , Kosovë 12000
              </p>
            </a>
          </div>
        </div>
        <div className="footer-links">
          <h3 className="fs-700 clr-white">{t("footer.products")}</h3>
          <div className="footer-links-columns flex">
            <div className="footer-links-column flex">
              <Link className="clr-white fs-500" to="/products">
                {t("catalogue.rectangular")}
              </Link>
              <Link className="clr-white fs-500" to="/products">
                {t("catalogue.circular")}
              </Link>
              <Link className="clr-white fs-500" to="/products">
                {t("catalogue.square")}
              </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.profileU")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.profileH")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.elipse")}
              </Link>
            </div>
            <div className="footer-links-column flex">
              <Link className="clr-white fs-500" to="/products">
                {t("catalogue.profileP")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.profileI")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.roundBars")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.profileL")}
          </Link>
          <Link className="clr-white fs-500" to="/products">
                {t("catalogue.flets")}
          </Link>
            </div>
          </div>
        </div>
        <div className="footer-more">
          <p className="fs-500 clr-white">{t("footer.socialMedia")}</p>
          <h4 className="clr-white fs-600">{t("footer.ourSocialMedia")}</h4>
          <div className="flex">
            <a
              href="https://www.instagram.com/metalteknikaasllani/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/icons/instagram.svg" alt="Instagram Icon" />
            </a>
            <a
              href="https://www.facebook.com/mtaASLLANI/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/icons/facebook.svg" alt="Facebook Icon" />
            </a>
            <a
              href="https://www.tiktok.com/@metaleknikaasllani"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/icons/tiktok.svg" alt="TikTok Icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="scrolltotop" onClick={scrollToTop}>
        <img src="/assets/icons/arrowUp.svg" alt="Arrow Up Icon" />
      </div>
      <div className="footer-bottom container">
        <p className="fs-400 clr-white">
          &copy; {new Date().getFullYear()} Brandivate.{" "}
          {t("footer.allRightsReserved")}
        </p>
      </div>
    </div>
  );
}

export default Footer;
